import { AppStateEnum } from '@/enums'

export type GlobalState = {
  appState: AppStateEnum,
  mini: boolean,
  isPendoLoaded: boolean,
}

export const state: GlobalState = {
  appState: AppStateEnum.loading,
  mini: false,
  isPendoLoaded: false,
}
